import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from '@/store/authStore'
import Layout from '@/components/Layout'
import Login from '@/pages/Login'
import Dashboard from '@/pages/Dashboard'
import Letters from '@/pages/Letters'
import LetterEditorPage from '@/pages/LetterEditorPage'
import ColdLetters from '@/pages/ColdLetters'
import ColdLetterEditorPage from '@/pages/ColdLetterEditorPage'
import ColdBusiness from '@/pages/ColdBusiness'
import Clients from '@/pages/Clients'
import Territories from '@/pages/Territories'
import Applications from '@/pages/Applications'
import Users from '@/pages/Users'
import Audit from '@/pages/Audit'
import Settings from '@/pages/Settings'
// Sales module pages
import SalesDashboard from '@/pages/sales/SalesDashboard'
import PlanningProspects from '@/pages/sales/PlanningProspects'
import WebsiteProspects from '@/pages/sales/WebsiteProspects'
import MyCommission from '@/pages/sales/MyCommission'
import SalesGuides from '@/pages/sales/SalesGuides'
// Admin sales pages
import SalesOverview from '@/pages/admin/SalesOverview'
import Payroll from '@/pages/admin/Payroll'
// Client portal
import ClientDashboard from '@/pages/client/ClientDashboard'

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)
  const hasHydrated = useAuthStore((state) => state._hasHydrated)

  // Wait for Zustand to hydrate from localStorage before making auth decisions
  if (!hasHydrated) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-[#f39c13]"></div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}

/**
 * Role-aware dashboard - shows appropriate dashboard based on user role
 */
function RoleBasedDashboard() {
  const user = useAuthStore((state) => state.user)

  if (user?.role === 'CLIENT') {
    return <ClientDashboard />
  }

  if (user?.role === 'SALES') {
    return <SalesDashboard />
  }

  return <Dashboard />
}

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<RoleBasedDashboard />} />
        <Route path="letters" element={<Letters />} />
        <Route path="letters/:id" element={<LetterEditorPage />} />
        <Route path="cold-letters" element={<ColdLetters />} />
        <Route path="cold-letters/:id" element={<ColdLetterEditorPage />} />
        <Route path="cold-business" element={<ColdBusiness />} />
        <Route path="clients" element={<Clients />} />
        <Route path="territories" element={<Territories />} />
        <Route path="applications" element={<Applications />} />
        <Route path="audit" element={<Audit />} />
        <Route path="users" element={<Users />} />
        <Route path="settings" element={<Settings />} />
        {/* Sales module routes */}
        <Route path="sales/planning" element={<PlanningProspects />} />
        <Route path="sales/website" element={<WebsiteProspects />} />
        <Route path="sales/commission" element={<MyCommission />} />
        <Route path="sales/guides" element={<SalesGuides />} />
        {/* Admin sales routes */}
        <Route path="admin/sales" element={<SalesOverview />} />
        <Route path="admin/payroll" element={<Payroll />} />
      </Route>
      
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default App
